import { LegalLayout, CLINIC } from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Términos y Condiciones de Uso">
      <h2>1. Aceptación de los términos</h2>
      <p>El registro de una cuenta y/o la reserva de una cita en {CLINIC.domain} implica la aceptación expresa
      de los presentes términos y condiciones, así como de la Política de Privacidad y del Consentimiento
      Informado de Telemedicina.</p>

      <h2>2. Servicio prestado</h2>
      <p>Se prestan servicios de medicina general en modalidad presencial y telemática (videoconsulta),
      incluyendo:</p>
      <ul>
        <li>Consulta médica privada con el Dr. Dimy Laguerre.</li>
        <li>Emisión de recetas médicas privadas REMPE-compatibles.</li>
        <li>Peticiones de pruebas diagnósticas (laboratorio e imagen).</li>
        <li>Chat médico orientativo asistido por IA (no diagnóstico).</li>
        <li>Acceso a historia clínica del paciente.</li>
      </ul>
      <p><strong>Limitaciones:</strong> el servicio no incluye atención de urgencias vitales. En caso de
      emergencia, contactar inmediatamente con el <strong>112</strong>.</p>

      <h2>3. Tarifas y forma de pago</h2>
      <p>El precio de la consulta se informa al usuario antes de la formalización de la cita. Los pagos se
      procesan a través de Stripe (tarjeta) o Wise (transferencia). La factura digital se emite tras el cobro.</p>
      <p>Cancelaciones con más de 24 horas de antelación: reembolso íntegro. Cancelaciones con menos de 24
      horas: el médico podrá retener hasta el 100% del importe en concepto de no presentación.</p>

      <h2>4. Obligaciones del paciente</h2>
      <ul>
        <li>Proporcionar información veraz y completa sobre su estado de salud, antecedentes y medicación.</li>
        <li>Mantener actualizada su información de contacto.</li>
        <li>Asistir puntualmente a las citas programadas.</li>
        <li>Disponer de conexión a internet estable y dispositivo con cámara/micrófono para
        videoconsultas.</li>
        <li>Comunicar cualquier reacción adversa o evolución desfavorable.</li>
      </ul>

      <h2>5. Obligaciones del médico</h2>
      <ul>
        <li>Prestar asistencia conforme a la lex artis y al código deontológico médico.</li>
        <li>Mantener el secreto profesional (Art. 199 Código Penal y Art. 10 Ley 41/2002).</li>
        <li>Custodiar la historia clínica del paciente conforme a la legislación vigente.</li>
        <li>Emitir documentación clínica con la diligencia debida.</li>
      </ul>

      <h2>6. Receta electrónica privada</h2>
      <p>Las recetas emitidas son <strong>privadas</strong> (no incluidas en la prestación farmacéutica de
      la Seguridad Social) y cumplen los requisitos del Real Decreto 1718/2010. Incluyen código QR de
      verificación pública y son válidas en farmacias del territorio nacional conforme al estatuto REMPE.</p>

      <h2>7. Conservación de la historia clínica</h2>
      <p>Conforme a la Ley 41/2002, la historia clínica se conservará durante un mínimo de 5 años y un máximo
      de 15 años desde la última asistencia, garantizando su confidencialidad e integridad.</p>

      <h2>8. Propiedad intelectual</h2>
      <p>La documentación clínica emitida es propiedad del paciente. La plataforma, software, marca, logo y
      diseño son propiedad del titular del servicio.</p>

      <h2>9. Limitación de responsabilidad</h2>
      <p>El médico asume la responsabilidad civil profesional derivada de su actuación conforme a la
      legislación vigente, dentro de los límites de su póliza de seguro de responsabilidad civil profesional.</p>
      <p>Quedan excluidas de responsabilidad las consecuencias derivadas de información incorrecta o
      incompleta facilitada por el paciente, problemas técnicos de conectividad ajenos al titular, o uso
      indebido de la plataforma.</p>

      <h2>10. Modificaciones</h2>
      <p>Los presentes términos pueden ser modificados para adaptarse a cambios normativos. Las modificaciones
      se comunicarán al usuario con al menos 30 días de antelación a su entrada en vigor cuando supongan
      cambios sustanciales.</p>

      <h2>11. Resolución de conflictos</h2>
      <p>Para cualquier controversia, las partes se someten a los Juzgados y Tribunales de Sevilla. El
      consumidor podrá también acudir a la Junta Arbitral de Consumo de Andalucía o a la plataforma europea
      de resolución de litigios en línea (ODR): <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a></p>
    </LegalLayout>
  );
}
